module.exports = __webpack_public_path__ + "static/media/button-add.bfeba3aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button-add.svg
// module id = 431
// module chunks = 0